import { maxUint16 } from '../../constants/number.js'

export const maxBytecodeSize = maxUint16 * 32n
